import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTotalTreeWeights } from "services/hooks";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { handleToggleCheckout } from "store/wizard";
import styles from "./../wizard.module.scss";

const BottomBar = () => {  
  const [missingSteps, setMissingSteps] = useState<number[]>([0,1,2,3,4,5,6]);
  const { selection } = useAppSelector((state) => state.wizard);
  const dispatch = useAppDispatch();
  const calculation = useTotalTreeWeights();

  useEffect(() => {
    const newMissingSteps:number[] = [];
    for (let i = 0; i <= 7; i++) {
      if (!(i in selection)) {
        newMissingSteps.push(i);
      }
    }
    setMissingSteps(newMissingSteps);
  },[selection]);
  
  return (
    <>
      <div className={`${styles.bottomBar} p-2 d-flex align-items-center justify-content-center`}>
        <div className={`${styles.counter} d-flex align-items-center`}>
          <Typography variant="body2">Trees to plant <span className={`${styles.sep}`}/><strong>{calculation.totalTrees}</strong> 🌳</Typography>
          {
            missingSteps.length === 0 && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => dispatch(handleToggleCheckout(true))}
              >
                Plant Now
              </Button>
            )
          }
        </div>
      </div>
    </>
  );
};
export default BottomBar;
